import { render, staticRenderFns } from "./drawer_ZhuyuanPetCage.vue?vue&type=template&id=b07a4d74&scoped=true&"
import script from "./drawer_ZhuyuanPetCage.vue?vue&type=script&lang=js&"
export * from "./drawer_ZhuyuanPetCage.vue?vue&type=script&lang=js&"
import style0 from "./drawer_ZhuyuanPetCage.vue?vue&type=style&index=0&id=b07a4d74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07a4d74",
  null
  
)

export default component.exports